module.exports = __webpack_public_path__ + "front/img/34.a308e038.png";